module.exports = __webpack_public_path__ + "img/长方形2.265730fd.jpg";